import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { API, axios } from '../utils/api';
import Anteprima from '../components/documenti/Anteprima';
import Icona from '../components/cliente/Icone';
import { CATALOGO, CATEGORIE, conteggio, giornoBreve, leggiDocumento, salvaBlob, scaricaZip } from '../utils/documenti';
import { nomeDelFile } from '../components/documenti/DocumentiPratica';
import '../components/staff/impostazioni.css';

// /admin/archivio (dal bottone "Archivio" di Documenti), nello stile delle pagine dello staff: tutti i documenti dei
// clienti che si possono vedere. Ricerca per cliente, tipo, categoria, data di caricamento, scadenza e "inviato a";
// zip della selezione. Ogni apertura e download finisce nel registro degli accessi.

const VUOTI = { q: '', tipo: '', categoria: '', dal: '', al: '', scadenza_entro: '', inviato_a: '' };

const ArchivioDocumenti = () => {
  const [filtri, setFiltri] = useState(VUOTI);
  const [risultati, setRisultati] = useState(null);
  const [scelti, setScelti] = useState(new Set());
  const [aperto, setAperto] = useState(null);

  const cerca = useCallback(async (f) => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    try {
      setRisultati((await axios.get(`${API}/archivio`, { params })).data);
      setScelti(new Set());
    } catch { toast.error('Ricerca non riuscita'); setRisultati([]); }
  }, []);
  useEffect(() => { cerca(VUOTI); }, [cerca]);

  const campo = (k) => ({ value: filtri[k], onChange: (e) => setFiltri({ ...filtri, [k]: e.target.value }) });
  const cambia = (id) => { const s = new Set(scelti); if (s.has(id)) s.delete(id); else s.add(id); setScelti(s); };
  // come nelle righe della pratica: si può scaricare senza doverlo prima aprire
  const scarica = async (d) => {
    try { salvaBlob(await leggiDocumento(d, 'scarica'), nomeDelFile(d)); } catch { toast.error('Non siamo riusciti a scaricarlo'); }
  };

  return (
    <main className="st wrap" data-testid="archivio-documenti">
      <div className="imp-head">
        <div><div className="k">Pratiche · <Link to="/admin/documenti" className="link">Documenti</Link></div><h1>Archivio</h1>
          <p>Tutto su archivio privato: si apre solo con il login, e ogni apertura resta registrata.</p></div>
        <button type="button" className="btn" disabled={!scelti.size}
          onClick={() => scaricaZip(`${API}/archivio/zip`, 'archivio-documenti.zip', { documenti: [...scelti] }).catch(() => toast.error('Zip non riuscito'))}>
          <Icona nome="scarica" />Scarica la selezione ({scelti.size})
        </button>
      </div>
      <section className="card" style={{ marginBottom: '1rem' }}>
        <form className="imp-campi" onSubmit={(e) => { e.preventDefault(); cerca(filtri); }}>
          <label>Cliente o file<input placeholder="Nome del cliente o del file" {...campo('q')} /></label>
          <label>Categoria
            <select {...campo('categoria')}>
              <option value="">Tutte le categorie</option>
              {Object.entries(CATEGORIE).map(([id, nome]) => <option key={id} value={id}>{nome}</option>)}
            </select>
          </label>
          <label>Tipo
            <select {...campo('tipo')}>
              <option value="">Tutti i tipi</option>
              {CATALOGO.tipi.map((t) => <option key={t.id} value={t.id}>{t.nome}</option>)}
            </select>
          </label>
          <label>Inviato a<input placeholder="banca, notaio…" {...campo('inviato_a')} /></label>
          <label>Caricato dal<input type="date" {...campo('dal')} /></label>
          <label>al<input type="date" {...campo('al')} /></label>
          <label>Scadenza
            <select {...campo('scadenza_entro')}>
              <option value="">Qualsiasi scadenza</option>
              <option value="30">Entro 30 giorni</option><option value="90">Entro 90 giorni</option><option value="365">Entro un anno</option>
            </select>
          </label>
          <div className="imp-azioni" style={{ alignSelf: 'end', marginTop: 0 }}>
            <button type="submit" className="btn sm p"><Icona nome="cerca" />Cerca</button>
            <button type="button" className="btn sm" onClick={() => { setFiltri(VUOTI); cerca(VUOTI); }}>Azzera</button>
          </div>
        </form>
      </section>
      <p className="imp-nota" style={{ marginBottom: '.6rem' }}>{risultati ? conteggio(risultati.length, 'documento', 'documenti') : 'Cerco…'}</p>
      {risultati && risultati.length > 0 && (
        <div className="tabella-box">
          <table className="tabella">
            <thead><tr><th><span className="sr-only">Scegli</span></th><th>Cliente</th><th>Documento</th><th>Caricato</th><th>Scadenza</th><th>Inviato a</th><th /></tr></thead>
            <tbody>
              {risultati.map((d) => (
                <tr key={d.id} data-testid={`documento-${d.id}`}>
                  <td><input type="checkbox" className="spunta-sola" checked={scelti.has(d.id)} onChange={() => cambia(d.id)} aria-label={`Scegli ${d.tipo_nome}`} /></td>
                  <td><Link className="link" to={`/admin/clienti/${d.cliente_id}#documenti`}>{d.cliente_nome}</Link></td>
                  <td>{d.tipo_nome}{d.periodo_testo ? ` · ${d.periodo_testo}` : ''}{d.solo_staff && <span className="tag t-b" style={{ marginLeft: '.4rem' }}>solo per noi</span>}<small>{d.nome_file}</small></td>
                  <td className="nowrap muto">{giornoBreve(d.data_upload)}</td>
                  <td className={`nowrap${d.scadenza_stato === 'scaduto' ? ' bad' : d.scadenza_stato === 'presto' ? ' w' : ' muto'}`}>{d.scadenza ? giornoBreve(d.scadenza) : '—'}</td>
                  <td className="muto">{(d.consegne || []).map((c) => c.ente).join(', ') || '—'}</td>
                  <td className="dx nowrap">
                    <button type="button" className="btn xs" onClick={() => setAperto(d)} aria-label={`Apri ${d.tipo_nome}`}>Apri</button>
                    <button type="button" className="btn xs" style={{ marginLeft: '.3rem' }} onClick={() => scarica(d)}
                      aria-label={`Scarica ${d.tipo_nome}`}>Scarica</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {aperto && <Anteprima doc={aperto} onChiudi={() => setAperto(null)} />}
    </main>
  );
};

export default ArchivioDocumenti;
